import axios from "axios";
import { ENV, validateErrorResponse } from "../config/ENV";
import axiosInterceptors from "./axiosInterceptors";

export const TemplateService = {
  showTemplatesService,
};

export function showTemplatesService(search) {
  return axiosInterceptors
    .get(ENV.getTemplatesUrl, {
      params: {
        search: search,
        ps: 0,
        pn: 0,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}
